import React from 'react';
import { ProfitAndLossCustom } from "components/containers/CustomProfitAndLoss";

const CustomProfitAndLoss = () => (
  <ProfitAndLossCustom />
);

export default CustomProfitAndLoss;
